import React, { FC, memo } from "react"
import { ProductsContainerPropsType } from "@/components/Products/Slider/types"
import { Typography } from "@/components/ui/Typography/Typography"
import { getBreakpointVal } from "@/styles/utils/Utils"
import { breakpoints } from "@/styles/utils/vars"
import { TITLES } from "@/utils/constants"
import { ProductsSlider } from "../../Slider"

const KitContentsContainer: FC<ProductsContainerPropsType> = memo(
  ({ products, ruleSort }) => {
    if (!products.length) {
      return null
    }
    return (
      <ProductsSlider
        slidesPerView={3}
        responsiveExtends={{
          [getBreakpointVal(breakpoints.lg)]: {
            slidesPerView: 3,
          },
          [getBreakpointVal(breakpoints.sm)]: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
          },
        }}
        products={products}
        ruleSort={ruleSort}
        disabledOnMobile
        title={<Typography variant={"h3"}>{TITLES.KIT_CONTENTS}</Typography>}
      />
    )
  },
)

KitContentsContainer.displayName = "CompanionsContainer"

export { KitContentsContainer }
